import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import ContactPage from "../pages/Contact/ContactPage";
import HomePage from "../pages/Home/HomePage";
import Policy from "../pages/Policy/Policy";
import ServicesPage from "../pages/Services/ServicesPage";
import TypoGraphy from "../pages/typograpy/Typograpy";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { gsap } from "gsap";
import AboutPage from "../pages/About/AboutPage";

function Router() {
  const location = useLocation();

  useEffect(() => {
    window.scroll({ top: 0 });
  }, [location]);

  const onEnter = (node) => {
    setTimeout(() => {
      gsap.fromTo(
        ".page",
        {
          y: 660,
          scale: 1,
          opacity: 0.6,
          ease: "power1.InOut",
        },
        {
          y: 0,
          scale: 1,
          opacity: 1,
          ease: "power1.InOut",
          duration: 0.6,
        }
      );
    }, 300);
  };

  const onExit = (node) => {
    gsap.to(".page", {
      scale: 0.95,
      opacity: 0.7,
      ease: "power1.InOut",
      duration: 0.2,
    });
  };
  return (
    <TransitionGroup component={null}>
      <CSSTransition
        key={location.key}
        timeout={5000}
        classNames="page"
        onExit={onExit}
        onEntering={onEnter}
        unmountOnExit
      >
        <div className="page">
          <Routes location={location}>
            <Route exact path="/" element={<HomePage />} />
            <Route exact path="/typo" element={<TypoGraphy />} />
            <Route exact path="/about" element={<AboutPage />} />
            <Route exact path="/services" element={<ServicesPage />} />
            <Route exact path="/contact" element={<ContactPage />} />
            <Route exact path="/private-policies" element={<Policy />} />
          </Routes>
        </div>
      </CSSTransition>
    </TransitionGroup>

    // </Routes>
  );
}

export default Router;
